import { dianDuBook, dianDuPage } from '../../api/diandu'
export default {
  namespaced: true,
  state: {
    bookData: {},
    pagesJson: {}
  },
  mutations: {
    setBookRightData(state, payload) {
      const { workbookId } = payload
      state.bookData[workbookId] = {
        ...state.bookData[workbookId],
        ...payload
      }
    },
    setPagesJson(state, payload) {
      const { chapterId } = payload
      state.pagesJson[chapterId] = {
        [chapterId]: {
          ...state.bookData[chapterId],
          ...payload
        }
      }
    }
  },
  actions: {
    // 获取书数据
    async getBookContent({ state, commit, dispatch }, { workbookId, chapterId, pageId }) {
      const data = await dispatch('getBookData', { workbookId })
      const {
        data: { book },
        pages,
        totle
      } = data
      const chapter = book.chapters.find((i) => i.id === chapterId)
      const page = chapter.pages.find((i) => i.id === pageId)
      const pageInChapterIndex = chapter.pages.findIndex((i) => i.id === pageId)
      const nextChapterId =
        pageInChapterIndex === chapter.pages.length - 1
          ? (book.chapters.find((i) => i.index === chapter.index + 1) || {}).id
          : chapterId
      const RelChapterIndex = book.chapters.find((i) => i.index === chapter.index + 1)
      const preChapterId =
        pageInChapterIndex === 0
          ? (book.chapters.find((i) => i.index === chapter.index - 1) || {}).id
          : chapterId
      const prePageId = (pages.find((i) => i.index === page.index - 1) || {}).id
      const nextPageId = (pages.find((i) => i.index === page.index + 1) || {}).id
      const isLastPage = pageInChapterIndex === chapter.pages.length - 1
      const isLastPageInbook = page.index === pages.length - 1
      return {
        nextChapterId,
        RelChapterIndex,
        preChapterId,
        prePageId,
        nextPageId,
        totle,
        isLastPage,
        isLastPageInbook,
        data: data.data,
        page,
        chapter
      }
    },
    // 获取书json
    async getBookData({ state, commit }, { workbookId }) {
      const { bookData } = state
      var data = {}
      if (
        bookData[workbookId] &&
        bookData[workbookId]['pageJson'] &&
        bookData[workbookId]['data']
      ) {
        data = bookData[workbookId]['data']
        return data
      } else {
        data = await dianDuBook(workbookId)
      }
      var totle = 0
      data.book.chapters.map((item, key) => {
        item['index'] = key
        item.pages.map((val, index) => {
          val['index'] = totle
          totle = totle + 1
          return val
        })
        return item
      })
      const pages = data.book.chapters.reduce((prev, curr) => {
        return [...prev, ...curr.pages]
      }, [])
      commit('setBookRightData', {
        workbookId,
        data,
        pages,
        totle
      })
      return { data, pages, totle }
    },
    // 获取单页数据
    async getPageContent({ state, commit }, { workbookId, chapterId, pageId }) {
      const { pagesJson } = state
      var dataPage = {}
      // if (pagesJson[chapterId] && pagesJson[chapterId]['dataJson']) {
      //   dataPage = pagesJson[workbookId]['chapterId']
      //   return dataPage
      // } else {
      dataPage = await dianDuPage(workbookId, chapterId, pageId)
      // }

      dataPage.pages.map((item, key) => {
        item['index'] = key
        return item
      })
      var indexData = dataPage.pages.find((item, index) => item.id === Number(pageId)) // 当前页的数据
      const nextData = dataPage.pages.find((i) => i.index === indexData.index + 1) || {}
      var pagesAll = {
        dataPage,
        indexData: indexData || false,
        nextData
      }
      // commit('setPagesJson', {
      //   chapterId,
      //   dataPage
      // })
      return pagesAll
    }
  }
}
